import { Button, Input } from '@pesto/ui';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useCreateProgramUserMutation } from '../../__generated__/graphql/api';
import { routes } from '../../constants/routes';

export const AddProgramUser = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [createProgramUser, { loading, error }] = useCreateProgramUserMutation();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await createProgramUser({ variables: { input: { ...formData, programId: id! } } });
      navigate(`${routes.programs}/${id}`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-4">
      <h1 className="mb-4 text-xl font-bold">Add Program User</h1>
      <form onSubmit={(event) => void handleSubmit(event)}>
        <div className="mb-4">
          <label htmlFor="firstName" className="block text-sm font-medium text-foreground">
            First Name
          </label>
          <Input
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
            className="mt-1 block w-full"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="lastName" className="block text-sm font-medium text-foreground">
            Last Name
          </label>
          <Input
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
            className="mt-1 block w-full"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block text-sm font-medium text-foreground">
            Email
          </label>
          <Input
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="mt-1 block w-full"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="phone" className="block text-sm font-medium text-foreground">
            Phone
          </label>
          <Input
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            className="mt-1 block w-full"
          />
        </div>
        <Button type="submit" variant="primary" loading={loading}>
          Add User
        </Button>
        {error && <p className="mt-2 text-sm text-destructive">{error.message}</p>}
      </form>
    </div>
  );
};
